<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-sys__roidailyreport}">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item>
          <el-select v-model="dataForm.channelId" filterable clearable placeholder="渠道名称">
            <el-option
                    v-for="item in channels"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            v-model="dateValue"
            type="daterange"
            :picker-options="pickerOptions"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="getTimes"
            value-format="yyyy-MM-dd"
            align="right">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button  type="primary" @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>
        <!-- <el-form-item>
          <el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('sys:roidailyreport:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('sys:roidailyreport:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
        </el-form-item> -->
      </el-form>
      <div class="info_box">
        <div class="info_box_item">
            <div class="tit_tip">买入总量和/个</div>
            <div class="number">{{ extraData.buyNo ? Number(extraData.buyNo).toLocaleString('en-US',{ minimumFractionDigits: 0, maximumFractionDigits: 0 }) : 0}}</div>
        </div>
        <div class="info_box_item">
            <div class="tit_tip">卖出总量和/个</div>
            <div class="number">{{ extraData.sellNo ? Number(extraData.sellNo).toLocaleString('en-US',{ minimumFractionDigits: 0, maximumFractionDigits: 0 }) : 0}}</div>
        </div>
        <div class="info_box_item">
            <div class="tit_tip">总收入/元</div>
            <div class="number"><span style="font-size: 18px;">￥</span>{{ extraData.income ? Number(extraData.income).toLocaleString('en-US',{ minimumFractionDigits: 2, maximumFractionDigits: 2 }) : 0}}</div>
        </div>
        <div class="info_box_item">
            <div class="tit_tip">总成本/元</div>
            <div class="number"><span style="font-size: 18px;">￥</span>{{ extraData.cost ? Number(extraData.cost).toLocaleString('en-US',{ minimumFractionDigits: 2, maximumFractionDigits: 2 }) : 0}}</div>
        </div>
        <div>
          <div class="info_box_item">
            <div class="roi">ROI= <span :style="{'color': extraData.roi < 1 ? '#ff482a' : '#4edb7c'}">{{ extraData.roi }}</span></div>
          </div>
        </div>
      </div>
      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
        <!-- <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column> -->
        <el-table-column prop="currentData" label="日期" header-align="center" align="center"></el-table-column>
        <el-table-column prop="channelName" label="渠道名称" header-align="center" align="center"></el-table-column>
        <el-table-column prop="chargingMode" label="渠道对接方式" header-align="center" align="center">
          <template slot-scope="scope">
            {{ getDictLabel(scope.row.chargingMode) }}
          </template>
        </el-table-column>
        <el-table-column prop="settlementMethod" label="渠道结算方式" header-align="center" align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.settlementMethod == '0'">固价</div>
            <div v-if="scope.row.settlementMethod == '1'">分润前</div>
            <div v-if="scope.row.settlementMethod == '2'">分润后</div>
          </template>
        </el-table-column>
        <el-table-column prop="buyPrice" label="渠道结算单价/买入结算总价" header-align="center" align="center">
          <template slot-scope="scope">
            {{ scope.row.settlementMethod == '0' ? scope.row.buyPrice : scope.row.totalCostPrice }}
          </template>
        </el-table-column>
        <el-table-column prop="salePrice" label="产品结算单价/卖出结算总价" header-align="center" align="center"></el-table-column>
        <el-table-column prop="buyNum" label="买入总数量" header-align="center" align="center"></el-table-column>
        <el-table-column prop="saleNum" label="卖出总数量" header-align="center" align="center"></el-table-column>
        <el-table-column prop="totalSalePrice" label="收入" header-align="center" align="center"></el-table-column>
        <el-table-column prop="totalCostPrice" label="成本" header-align="center" align="center"></el-table-column>
        <el-table-column prop="roi" label="ROI" header-align="center" align="center"></el-table-column>
        <!-- <el-table-column prop="creator" label="创建者" header-align="center" align="center"></el-table-column> -->
        <!-- <el-table-column prop="createDate" label="创建时间" header-align="center" align="center"></el-table-column> -->
        <!-- <el-table-column prop="updater" label="更新者" header-align="center" align="center"></el-table-column> -->
        <!-- <el-table-column prop="updateDate" label="更新时间" header-align="center" align="center"></el-table-column> -->
        <!-- <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <el-button v-if="$hasPermission('sys:roidailyreport:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}</el-button>
            <el-button v-if="$hasPermission('sys:roidailyreport:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button>
          </template>
        </el-table-column> -->
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './roidailyreport-add-or-update'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/sys/roidailyreport/page',
        getDataListIsPage: true,
        exportURL: '/sys/roidailyreport/export',
        deleteURL: '/sys/roidailyreport',
        deleteIsBatch: true
      },
      dataForm: {
        id: ''
      },
      dateValue: '',
      channels:[],
      modeList:[],
      pickerOptions: {
          shortcuts: [
          {
            text: '今天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              picker.$emit('pick', [start, end]);
            }
          },
            
          {
            text: '昨天',
            onClick(picker) {
              console.log(picker)
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              end.setTime(end.getTime() - 3600 * 1000 * 24);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '过去七天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: "上周",
            onClick(picker) {
              // 上周开始时间
              const starta = new Date();
              var first = starta.getDate() - starta.getDay() - 6;
              var startDate = new Date(starta.setDate(first));
              const start = new Date(startDate);
              start.setHours(0, 0, 0, 0);
              //  上周结束时间
              var currentDate = new Date();
              var firsts = currentDate.getDate() - currentDate.getDay() - 6;
              var last = firsts + 6;
              var endDate = new Date(currentDate.setDate(last));
              const end = new Date(endDate);
              end.setHours(23, 59, 59, 0);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "本周",
            onClick(picker) {
              var end = new Date();
              var week = end.getDay();
              console.log(week,'week')
              //一天的毫秒数
              var millisecond = 1000 * 60 * 60 * 24;
              //减去的天数
              var minusDay = week != 0 ? week - 1 : 6;
              
              //本周 周一
              var monday = new Date(end.getTime() - minusDay * millisecond);
              const start = new Date(monday);
              start.setHours(0, 0, 0, 0);
              console.log("2312", start, end);
              picker.$emit("pick", [start, end]);
            },

          },
       ]
      },
    }
  },
  components: {
    AddOrUpdate
  },
  created() {
    this.getchannelsOptions();
    this.getModeOptions()
  },
  methods:{
    getTimes() {
        if (this.dateValue != null) {
          this.dataForm.startDate = this.dateValue[0]
          this.dataForm.endDate = this.dateValue[1]
        }else{
          delete this.dataForm.startDate 
        delete this.dataForm.endDate
        }
      },
     //初始化渠道下拉框中的选项
     async getchannelsOptions() {
      this.$http.get(`/sys/channels/list`).then(({data: res}) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.channels = [];
        if (res.data != null) {
          res.data.forEach(element => {
            this.channels.push({label: element.name, value: element.id})
          })
        }
      }).catch(() => {
      })
    },
    getDictLabel(value) {
      const dictItem = this.modeList.find(item => item.value == value);
      return dictItem ? dictItem.label : ''; 
    },
    //初始化下拉框中的选项
    async getModeOptions() {
      this.$http.get(`/sys/dict/data/list?dataType=charging_mode`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.citys=[];
        if (res.data!=null){
          res.data.forEach(element => {
            this.modeList.push({label:element.dictLabel,value:element.dictValue})
          })
        }
      }).catch(() => {})
    },
  }
}
</script>
<style scoped lang="scss">
.info_box{
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding: 30px;
  border: 1px solid #d7d7d7;
  margin-bottom: 30px;
  .info_box_item{
    margin: 0px 20px;
    .tit_tip{
      font-size: 14px;
      font-weight: bold;
      color: #666666;
    }
    .number{
      font-size: 24px;
      font-weight: bold;
      color: #000;
      margin-top: 5px;
    }
    .roi{
      margin-left: 40px;
      font-size: 30px;
      color: #666;
      font-weight: bold;
    }
  }
}
</style>